module.exports = __webpack_public_path__ + "static/img/2.9605b37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/logos/2.svg
// module id = 697
// module chunks = 1